import { render, staticRenderFns } from "./ClockCreationButton.vue?vue&type=template&id=666ee95c&scoped=true&"
import script from "./ClockCreationButton.vue?vue&type=script&lang=js&"
export * from "./ClockCreationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666ee95c",
  null
  
)

export default component.exports